import { createApp } from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import apiInstance from './axios';

import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';

const app = createApp(App);

app.use(store);
app.use(router);
app.use(Antd);

app.config.globalProperties.$apiInstance = apiInstance;
app.mount('#app');
